import React from "react";
import styles from "./Card.module.css";

const Card = ({ title, children }) => {
	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<h3 className={styles.headerTitle}>{title}</h3>
			</div>
			<div className={styles.divider}></div>
			<div className={styles.content}>{children}</div>
		</div>
	);
};

export default Card;
